import { createBrowserRouter } from 'react-router-dom';
import Dashboard from './Components/Splitter/Dashboard/Dashboard';
import Reviews from './Components/User/Reviews/Reviews';
import ShareDocuments from './Components/User/ShareDocuments/ShareDocuments';
import PaymentQuoteExpert from './Components/Expert/PaymentQuote/PaymentQuoteExpert';
import WaitingAcceptationExpert from './Components/Expert/WaitingAcceptationExpert/WaitingAcceptationExpert';
import History from './Components/Expert/History/History';
import Login from './Components/Connection/Login/Login';
import OTP from './Components/Connection/OTP/OTP';
import AcceptedRdvExpert from './Components/Expert/AcceptedRdvExpert/AcceptedRdvExpert';
import ToastProvider from './Components/Contexts/toastProvider';
// import CheckoutVerification from './Components/Expert/Stripe/CheckoutVerification';
// import CheckoutSuccess from './Components/Expert/Stripe/CheckoutSuccess';
// import CheckoutCancel from './Components/Expert/Stripe/CheckoutCancel';
import Settings from './Components/Shared/Settings/Settings';
import Error404 from './Components/404/Error404';
import AcceptedRdvUser from './Components/User/AcceptedRdvUser/AcceptedRdvUser';
import WaitingAcceptationUser from './Components/User/WaitingAcceptation/WaitingAcceptationUser';
import Quotes from './Components/User/Quotes/Quotes';
import ForgotPassword from './Components/Shared/ForgotPassword/ForgotPassword';

const router = createBrowserRouter([
	{
		path: '/',
		element: <ToastProvider />,
		children: [
			{
				path: '*',
				element: <Error404 />,
			},
			{
				path: '/',
				index: true,
				element: <Dashboard />,
			},
			{
				path: '/waiting-acceptation',
				element: <WaitingAcceptationExpert />,
			},
			{
				path: '/accepted-rdv',
				element: <AcceptedRdvExpert />,
			},
			{
				path: '/reviews',
				element: <Reviews />,
			},
			{
				path: '/share-documents',
				element: <ShareDocuments />,
			},
			{
				path: '/payment-quote',
				element: <PaymentQuoteExpert />,
			},
			{
				path: '/client-history',
				element: <History />,
			},
			{
				path: '/login',
				element: <Login />,
			},
			{
				path: '/otp',
				element: <OTP />,
			},
			// {
			// 	path: '/stripe/checkout',
			// 	element: <CheckoutVerification />,
			// },
			// {
			// 	path: '/stripe/checkout/success/:checkoutId',
			// 	element: <CheckoutSuccess />,
			// },
			// {
			// 	path: '/stripe/checkout/cancel',
			// 	element: <CheckoutCancel />,
			// },
			{
				path: '/settings',
				element: <Settings />,
			},
			{
				path: '/accepted-quotes',
				element: <AcceptedRdvUser />,
			},
			{
				path: '/waiting-acceptations',
				element: <WaitingAcceptationUser />,
			},
			{
				path: '/quotes',
				element: <Quotes />,
			},
			{
				path: '/forgot-password',
				element: <ForgotPassword />,
			},
		],
	},
]);

export default router;
